import { render, staticRenderFns } from "./cabinet-fl223-notice-card-publish-button.vue?vue&type=template&id=67ac9105&"
import script from "./cabinet-fl223-notice-card-publish-button.vue?vue&type=script&lang=js&"
export * from "./cabinet-fl223-notice-card-publish-button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev2/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67ac9105')) {
      api.createRecord('67ac9105', component.options)
    } else {
      api.reload('67ac9105', component.options)
    }
    module.hot.accept("./cabinet-fl223-notice-card-publish-button.vue?vue&type=template&id=67ac9105&", function () {
      api.rerender('67ac9105', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/cabinet/fl223/cards/partials/cabinet-fl223-notice-card-publish-button.vue"
export default component.exports